import { useMemo, useState } from 'react';
export function useBKJTimeInputContextHooks(initialInputValue = '') {
    const [inputValue, setInputValue] = useState(initialInputValue);
    const [anchorElement, setAnchorElement] = useState();
    const [dropdownElement, setDropdownElement] = useState();
    const values = useMemo(() => ({ inputValue, anchorElement, dropdownElement }), [inputValue, anchorElement, dropdownElement]);
    const setMethods = useMemo(() => ({ setInputValue, setAnchorElement, setDropdownElement }), []);
    return [values, setMethods];
}
//# sourceMappingURL=BKJTimeInput.context.hooks.js.map